// external libs
import React from 'react'
import { Grid } from '@material-ui/core'
import arrayMutators from 'final-form-arrays'
import { Form, FormSpy } from 'react-final-form'

// stores & hooks
import useManageProjectStore from '../../../../../../stores/manageProject/useManageProjectStore'
import useRequestForm from './useProjectRenewalAndAmendment'
import useSnackbarAction from '../../../../../../stores/snackbar/snackbarAction'
import useTranslate from '../../../../../../i18n/useTranslate'

// constants
import constSubmittedStatus from '../../../../../../constants/submittedStatus'
import constSubmittedStep from '../../../../../../constants/submittedStep'

// ui components
import Dialog from '../../../../../../control/dialog/dialog'
import EthicsForm from '../../../../shareUI/ethicsForm/ethicsForm'
import RemarkFromAdmin from '../../../../shareUI/remarkFromAdmin/remarkFromAdmin'
import UploadDoc from '../../../../shareUI/uploadDoc/uploadDoc'

// page components
import PageAction from '../../pageAction'
import ResearcherForm from '../../../../shareUI/researcherForm/researchForm'

// types
import * as requestFormType from './projectRenewalAndAmendmentType'
import useCheckPermission from '../../../../../../utilities/checkPermission'
import UploadAdditionalDoc from '../../../../shareUI/uploadAdditionalDoc/UploadAdditionalDoc'

type ErrorsType = {
    langTH?: string
    langEN?: string
}

//View
const RequestFormView = (props: requestFormType.RequestFormView) => {
    const {
        onClickSubmit,
        onClickCancel,
        onRefDialogTwo,
        configDialog,
        handleChangeFaculty,
        selectedIrb,
        isApproveWithComment,
        isEditAfterReview = false,
        btnClose,
        initialData = {},
        isViewMode = false,
        initialUploadFile = [],
        projectData,
        handleDirtyChange,
        onChangeResearcherType,
        valuesForm,
        formValueRef,
        isDraftData,
        onClickDeleteProject,
    } = props

    const manageProjectStore = useManageProjectStore()
    const snackbarAction = useSnackbarAction()
    const checkPermission = useCheckPermission()
    const canUpdateDocument = checkPermission.checkCanUpdateDocument(projectData)

    const { documentTopic } = manageProjectStore

    const translate = useTranslate()
    const uploadFileinit = documentTopic?.map(() => {
        return {
            uploadFileObj: {
                fileList: [],
                subTopicPageList: [],
            },
        }
    })

    const isNotCompleteDocument = projectData?.submittedStatusInfo?.value === constSubmittedStatus.incorrectDocument
    const isDisableDoc = isViewMode && (!isNotCompleteDocument || !isApproveWithComment)

    let isUploadEditMode = false
    if (isApproveWithComment || isNotCompleteDocument || isEditAfterReview) {
        isUploadEditMode = true
    }

    return (
        <Form
            onSubmit={onClickSubmit}
            mutators={{
                ...arrayMutators,
            }}
            initialValues={{
                ...initialData,
                uploadFile: initialUploadFile && initialUploadFile.length > 0 ? initialUploadFile : uploadFileinit,
                documentAdditionalInfo: projectData?.documentAdditionalInfo ?? [],
            }}
            keepDirtyOnReinitialize={true}
            validate={(values) => {
                const errors: ErrorsType = {}
                if (!values.langTH && !values.langEN) {
                    errors.langTH = translate.get('MESSAGE.M016')

                    errors.langEN = translate.get('MESSAGE.M016')
                }

                return errors
            }}
        >
            {({ handleSubmit, form, dirty, invalid, errors, values }) => {
                valuesForm.current = values
                if (formValueRef) formValueRef.current = values
                return (
                    <React.Fragment>
                        <Grid container spacing={2}>
                            {projectData?.verifyDocument === false && (
                                <Grid item xs={12}>
                                    <RemarkFromAdmin
                                        isShow={projectData?.verifyDocument === false}
                                        projectData={projectData ?? undefined}
                                    />
                                </Grid>
                            )}

                            <Grid item xs={12}>
                                <EthicsForm
                                    callbackChangeFaculty={handleChangeFaculty}
                                    disabled={isViewMode || isApproveWithComment}
                                    isNotCompleteDocument={isNotCompleteDocument}
                                    isDisableRIB={true}
                                    isDisablePhase={isViewMode || isApproveWithComment}
                                    isDisableNumPhase={isViewMode || isApproveWithComment}
                                    isShowNeedEditForm={false}
                                    isDisableNeedEditForm={true}
                                    isNeedEditForm={true}
                                    isEditAfterReview={isEditAfterReview}
                                    callbackChangeResearcherType={onChangeResearcherType}
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <ResearcherForm disabled={isViewMode || isApproveWithComment} />
                            </Grid>

                            <Grid item xs={12}>
                                <UploadDoc
                                    documentTitleList={documentTopic}
                                    initialData={initialUploadFile}
                                    selectedIrb={selectedIrb}
                                    isViewMode={isDisableDoc && !canUpdateDocument}
                                    latestDocument={projectData?.latestDocument}
                                    isUseUploadfileEdit={isUploadEditMode}
                                />
                            </Grid>

                            <Grid item xs={12} >
                                <UploadAdditionalDoc isViewMode={isDisableDoc && !canUpdateDocument} />
                            </Grid>

                            {!btnClose || canUpdateDocument ? (
                                <Grid item xs={12}>
                                    <PageAction
                                        onClickDeleteProject={
                                            isDraftData
                                                ? () => {
                                                      onClickDeleteProject()
                                                  }
                                                : undefined
                                        }
                                        onClickClose={() => {
                                            onClickCancel(dirty)
                                        }}
                                        onClickSave={() => {
                                            form.change('submitType', 'save')
                                            handleSubmit()
                                            invalid &&
                                                errors &&
                                                snackbarAction.openSnackbar({
                                                    message: translate.get('MESSAGE.M012'),
                                                    type: 'error',
                                                })
                                        }}
                                        onClickSaveDraft={() => {
                                            form.change('submitType', 'draft')
                                            handleSubmit()
                                        }}
                                    />
                                </Grid>
                            ) : null}
                        </Grid>

                        <Dialog onRef={onRefDialogTwo} {...configDialog} />
                        <FormSpy subscription={{ dirty: true }} onChange={handleDirtyChange} />
                    </React.Fragment>
                )
            }}
        </Form>
    )
}

//Controller
const RequestFormCtrl = (props: requestFormType.RequestFormType) => {
    const requestFormModel = useRequestForm(props)
    return <RequestFormView {...requestFormModel} {...props} />
}
export default RequestFormCtrl
